import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import { constants } from 'cng-web-lib'
import SmsConfigurationKeys from 'src/constants/locale/key/SmsConfiguration'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  let errMsgNumeric = translate(
    Namespace.SMS_CONFIGURATION,
    SmsConfigurationKeys.Validations.ERROR_MSG_NUMERIC
  )

  let errMsgMaxLength = translate(
    Namespace.SMS_CONFIGURATION,
    SmsConfigurationKeys.Validations.ERROR_MSG_MAX_LENGTH
  )

  let regexNumeric = "^[0-9]*$"

  return Yup.object({
    id: Yup.string(),
    content: Yup.string().nullable().required(requiredMessage).max(140, errMsgMaxLength + ' 140'),
    startDate: Yup.date().nullable().validFormat().typeError(dateTypeErrorMessage).required(requiredMessage),
    endDate: Yup.date().nullable().validFormat().typeError(dateTypeErrorMessage).required(requiredMessage),
    priority: Yup.string().nullable().required(requiredMessage).matches(regexNumeric, errMsgNumeric).max(3, errMsgMaxLength + ' 3'),
    active: Yup.string(),
    createdBy: Yup.string(),
    createdDate: Yup.date().validFormat().typeError(dateTypeErrorMessage),
    updatedBy: Yup.string(),
    updatedDate: Yup.date().validFormat().typeError(dateTypeErrorMessage),
    version: Yup.string(),
    smsConfigurationWhiteLabelGroup: Yup.array(),
  })
}

export default makeValidationSchema
